import React, { FC, memo } from 'react';
import { Box } from './styles';
import { Props } from './types';

const Checkbox: FC<Props> = ({ ...rest }) => <Box type="checkbox" {...rest} />;

export default memo(Checkbox);
